import React from 'react';
import {NavLink} from "react-router-dom";

const Logo = () => {
    return (
        <NavLink to={'/'}>
            <img className={'logo_main'} src={'/logo_black.svg'} alt={'ColdWare'}/>
        </NavLink>
    );
};

export default Logo;